export default __webpack_public_path__ + "static/media/webdev.9f27f335.png";